export const DATETIME_FORMAT = {
  'zh-CN': 'MM月DD日 HH时mm分ss秒',
  'en-US': 'MM-DD hh:mm:ss A',
  'es-MX': 'DD-MM hh:mm:ss A',
  'es-419': 'DD-MM hh:mm:ss A',
  'pt-BR': 'DD-MM hh:mm:ss A',
  'ja-JP': 'MM月DD日 HH:mm:ss'
}

// 日期字符串格式化规则
export const DATE_STRING_FORMAT_RULES = {
  'zh-CN': 'YYYY年MM月DD日',
  'en-US': 'MM.DD.YYYY',
  'es-MX': 'DD.MM.YYYY',
  'es-419': 'DD.MM.YYYY',
  'pt-BR': 'DD.MM.YYYY',
  'ja-JP': 'YYYY/MM/DD'
}

// Element-ui规则的日期格式
export const DATETIME_FORMAT_ELE = {
  'zh-CN': 'yyyy年MM月dd日',
  'en-US': 'MM.dd.yyyy',
  'es-MX': 'dd.MM.yyyy',
  'es-419': 'dd.MM.yyyy',
  'pt-BR': 'dd.MM.yyyy',
  'ja-JP': 'yyyy/MM/dd'
}
